// extracted by mini-css-extract-plugin
module.exports = {"ul":"paginate_ul__nQdw5","li":"paginate_li__BLmAT","liNone":"paginate_liNone__3bkUf","color":"paginate_color__32rqb"};